import { useMediaQuery, useTheme } from "@mui/material";

export const useDesktopView = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("lg"));
};
